module.exports = __webpack_public_path__ + "img/5.fb3a26c2.svg";